module.exports = __webpack_public_path__ + "static/media/style_img_1.2574c325.png";